"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var styleUrl_exports = {};
__export(styleUrl_exports, {
  blockStyleUrls: () => blockStyleUrls,
  featureFieldStyleUrl: () => featureFieldStyleUrl,
  formStyleUrls: () => formStyleUrls,
  pageStyleUrls: () => pageStyleUrls
});
module.exports = __toCommonJS(styleUrl_exports);
var import_client = require("@cartographerio/client");
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_lodash = require("lodash");
function featureFieldStyleUrl(apiConfig, mapStyle, options) {
  const { workspace, project, base = import_types.MapBaseEnum.Terrain } = options;
  switch (mapStyle.type) {
    case "Cartographer":
      return import_client.endpoints.map.style.v2.singleLayer(apiConfig, mapStyle.layer, {
        project: mapStyle.project ?? project,
        workspace,
        base: mapStyle.base ?? base
      });
    case "External":
      return typeof mapStyle.styleUrl === "string" ? mapStyle.styleUrl : mapStyle.styleUrl[base];
    default:
      return (0, import_util.checkExhausted)(mapStyle);
  }
}
function blockStyleUrls(apiConfig, block, options) {
  switch (block.type) {
    case "TextField":
    case "TextArea":
    case "Autocomplete":
    case "IntegerField":
    case "NumberField":
    case "Select":
    case "MultiSelect":
    case "Checkbox":
    case "UserRefField":
    case "TimestampField":
    case "AttachmentField":
    case "TeamField":
    case "Heading":
    case "Text":
    case "DynamicValue":
    case "DynamicGrid":
    case "DynamicImage":
    case "PrimarySurveyorField":
    case "PrimaryTeamField":
      return [];
    case "PointField":
    case "LineStringField":
    case "PolygonField":
      return [import_client.endpoints.map.style.v2.base(apiConfig, options.base)];
    case "FeatureField":
    case "NearestFeatureField":
      return [featureFieldStyleUrl(apiConfig, block.mapOptions.mapStyle, options)];
    case "Group":
      return block.blocks.flatMap((block2) => blockStyleUrls(apiConfig, block2, options));
    case "Card":
    case "FullWidth":
    case "Repeat":
    case "RequireRole":
    case "Scope":
    case "Visibility":
      return blockStyleUrls(apiConfig, block.block, options);
    default:
      return (0, import_util.checkExhausted)(block);
  }
}
function pageStyleUrls(apiConfig, page, options) {
  return page.blocks.flatMap((block) => blockStyleUrls(apiConfig, block, options));
}
function formStyleUrls(apiConfig, form, options) {
  return (0, import_lodash.uniq)(form.pages.flatMap((page) => pageStyleUrls(apiConfig, page, options)).sort());
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  blockStyleUrls,
  featureFieldStyleUrl,
  formStyleUrls,
  pageStyleUrls
});
//# sourceMappingURL=styleUrl.js.map
